import { cn } from '@app/utils/cn';
import { Skeleton } from '@typings';

import { SkeletonBase } from '../SkeletonBase';

export const InputSkeleton = ({ color, size, label }: Skeleton.InputSkeleton) => (
  <div>
    {label && <SkeletonBase className="mb-1 h-5 w-24" color={color} />}
    <SkeletonBase
      className={cn('h-10', {
        'h-8': size === 'medium',
      })}
      color={color}
    />
  </div>
);
